import { VildVersion } from './vildversion.model';

export class VildVersionExtended {
  public file_vildDbf: File;
  public file_pointShp: File;
  public file_pointShx: File;
  public file_pointPrj: File;
  public file_pointDbf: File;
  public file_lineShp: File;
  public file_lineShx: File;
  public file_linePrj: File;
  public file_lineDbf: File;
  public file_areaShp: File;
  public file_areaShx: File;
  public file_areaPrj: File;
  public file_areaDbf: File;

  constructor(public vildVersion: VildVersion) {}
  // other fields to be set after
}



// WEBPACK FOOTER //
// ./src/app/models/vildversionextended.model.ts